import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[680px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Vibrant%20abstract%20manga%20comic%20themed%20background%20with%20warm%20orange%20red%20and%20golden%20gradients%2C%20dynamic%20speed%20lines%2C%20comic%20halftone%20dots%20pattern%2C%20Japanese%20manga%20screen%20tone%20texture%2C%20energetic%20atmosphere%2C%20artistic%20illustration%20style%2C%20no%20characters%2C%20abstract%20composition&width=1800&height=900&seq=manga-hero-bg&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65 z-[1]"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
            <i className="ri-fire-line text-accent-400 text-sm"></i>
            <span className="text-background-50 text-sm font-medium whitespace-nowrap">类似4399漫画网 · 免费漫画推荐平台</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-5">
            发现你的下一部
            <span className="text-primary-400">心头好漫画</span>
          </h1>

          <p className="text-background-50/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            推荐韩漫、日漫、国漫全集大全，支持<strong>下拉式阅读</strong>，轻松<strong>追更收藏</strong>热门漫画。
            寻找类似<strong>4399漫画网</strong>的同类型优质漫画平台，99漫画为你一站搞定。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/korean"
              className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 whitespace-nowrap text-base cursor-pointer"
            >
              <i className="ri-compass-3-line mr-2"></i>
              开始探索
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-background-50 font-medium rounded-lg transition-all duration-200 whitespace-nowrap text-base border border-white/20 cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            {[
              { num: '50万+', label: '日活跃用户' },
              { num: '10万+', label: '收录漫画' },
              { num: '98.6%', label: '用户好评' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="font-heading text-2xl md:text-3xl text-background-50">{stat.num}</div>
                <div className="text-xs text-background-50/60 mt-1 whitespace-nowrap">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}